import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";

export const widgetSettingsApi = createApi({
    reducerPath: "widgetSettingsApi",
    tagTypes: ["widgetSettings"],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: (build) => ({
        getWidgetSettings: build.query({
            query: (data) => ({
                url: api.widgetSettings.getSettings(data.widgetable_id),
                method: "GET",
                params: data,
            }),
            providesTags: ["widgetSettings"],
        }),
        updateWidgetSettings: build.mutation({
            query: (settings) => ({
                url: api.widgetSettings.updateSettings(),
                method: "POST",
                body: settings,
            }),
            invalidatesTags: ["widgetSettings"],
        }),
    }),
});

export const {
    useLazyGetWidgetSettingsQuery, useUpdateWidgetSettingsMutation
} = widgetSettingsApi;
